import { userService } from '../services';
import config from '../config/config';

export const AnalyticsDashoardAction = {
    getVehcileTripsAnalytics,
    getWeeklyTripComparison,
    getLowCoverageVehicles,
    getPerformanceStatus,
    getSummerPlan,
    getScheduledVsActualTrips,
    getUnverifiedDPLs,
    getEmergencyPerformanceStatus,
    getMonthlyTripComparison,
    getYearlyTripComparison,
};

async function getVehcileTripsAnalytics(payload) {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.vehcileTripsAnalyticsUrl}`
        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                // alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch (error) {
        console.log("error", error);
        return null;
    }
}


async function getWeeklyTripComparison() {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.weeklyTripComparisonUrl}`
        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return (response.data);
        }
        else {
            console.log(response)
            if (response.status != 500) {
                // alert(response.data.message);
            }
            if (response.status == 401) {
                alert(response.data.message);
            }
            return null;
        }
    }
    catch (error) {
        console.log("error", error);
        return null;
    }
}





async function getLowCoverageVehicles() {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.lowCoverageVehiclesUrl}`;
        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}


async function getPerformanceStatus(payload) {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.performanceStatusUrl}?filter=${payload.dateRange}`;

        // Append fromDate/toDate only for CUSTOM filter
        if (payload.dateRange === 'CUSTOM' && payload.fromDate && payload.toDate) {
            apiEndpoint += `&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
        }

        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}

async function getEmergencyPerformanceStatus(payload) {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.emergencyPerformanceStatusUrl}?filter=${payload.dateRange}`;

        if (payload.dateRange === 'CUSTOM' && payload.fromDate && payload.toDate) {
            apiEndpoint += `&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;
        }

        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}

async function getSummerPlan() {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.summerPlanUrl}`;
        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}

async function getScheduledVsActualTrips(payload) {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.scheduledVsActualTripsUrl}`;
        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}

async function getUnverifiedDPLs() {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.unverifiedDPlUrl}`;
        let response = await userService.get(apiEndpoint);
        console.log("response-ccc-dpl", response)
        if (response && response.status == 200) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.log("error", error);
        return null;
    }
}

async function getMonthlyTripComparison(payload) {
    try {

        let apiEndpoint = `${config.baseUrl}${config.apiName.monthlyTripComparisonUrl}`;

        if (payload && payload.emergencySiteId) {
            apiEndpoint += `?siteId=${payload.emergencySiteId}`;
        }

        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        else {
            console.log("Monthly API error, using dummy data");

        }
    }
    catch (error) {
        console.log("error", error);
        console.log("Using dummy monthly data for development");
    }
}

async function getYearlyTripComparison(payload) {
    try {
        let apiEndpoint = `${config.baseUrl}${config.apiName.yearTripComparisonUrl}`;

        if (payload && payload.emergencySiteId) {
            apiEndpoint += `?siteId=${payload.emergencySiteId}`;
        }

        let response = await userService.get(apiEndpoint);
        if (response && response.status == 200) {
            return response.data;
        }
        else {
            console.log("Yearly API error, using dummy data");
        }
    }
    catch (error) {
        console.log("error", error);
        console.log("Using dummy yearly data for development")
    }
}
